export interface IBookmark {
  user_id: string;
  context_id: number;
  center;
  bbox;
  active_layers: string;
}

export interface IBookmarkList extends IBookmark {
  id: number;
  name: string;
  description: string;
  private: boolean;
  isFavourite?: boolean;
}

